import app from 'flarum/common/app';

app.initializers.add('huseyinfiliz-sort-changer-common', () => {
  console.log('[huseyinfiliz/sort-changer] Hello, forum and admin!');
});
